import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '@/components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { KeyRound, ListChecks } from 'lucide-react';
import McpAuthorizations from './McpAuthorizations';
import McpAudit from './McpAudit';

function McpHub({ user }) {
  const [params, setParams] = useSearchParams();
  const tab = params.get('aba') === 'auditoria' ? 'auditoria' : 'autorizacoes';

  return (
    <Layout user={user}>
      <div className="max-w-5xl mx-auto p-6 space-y-4" data-testid="mcp-hub-page">
        <h1 className="text-2xl font-semibold text-gray-900">Conector Claude</h1>
        <Tabs value={tab} onValueChange={(v) => setParams(v === 'auditoria' ? { aba: 'auditoria' } : {})}>
          <TabsList>
            <TabsTrigger value="autorizacoes" data-testid="mcp-tab-authorizations">
              <KeyRound className="w-4 h-4 mr-2" /> Autorizações
            </TabsTrigger>
            <TabsTrigger value="auditoria" data-testid="mcp-tab-audit">
              <ListChecks className="w-4 h-4 mr-2" /> Auditoria
            </TabsTrigger>
          </TabsList>
          <TabsContent value="autorizacoes"><McpAuthorizations /></TabsContent>
          <TabsContent value="auditoria"><McpAudit /></TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}

export default McpHub;
